import Requisicao from "./RequisicaoService";

class ClienteContaEmailService {            
    static async getSenha(id) {               
        return Requisicao.get('cliente-conta-email/password/' + id);
    }   
    
    static async atualizarSenha(id, senha) {        
        return Requisicao.patch('cliente-conta-email/password', {
            id: id,
            senha: senha
        });
    }   
}

export default ClienteContaEmailService;